import { render, staticRenderFns } from "./CompareWhyWeLoveIt.vue?vue&type=template&id=68c22eb0&"
import script from "./CompareWhyWeLoveIt.vue?vue&type=script&lang=js&"
export * from "./CompareWhyWeLoveIt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports